<template>
   <div>
	   <b-table :items="viewPricingArray" :fields="fieldsForPricingItems" class="table-striped">
		   <template slot="number" slot-scope="data">
			   <strong>{{ data.index + 1 }}</strong>
		   </template>
		   <template slot="incomingPriceUzs" slot-scope="data">
			   {{ data.item.incomingPriceUzs | currency({
			   symbol:
			   userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }) }}
		   </template>
		   <template slot="priceUzs" slot-scope="data">
			   {{ data.item.priceUzs | currency({
			   symbol:
			   userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }) }}
		   </template>
		   <template slot="priceWholesale" slot-scope="data">
			   {{ data.item.priceWholesale | currency({
			   symbol:
			   userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }) }}
		   </template>
	   </b-table>
   </div>

</template>

<script>
    import {mapState} from "vuex";

	export default {
        name: "viewPriceing",
		props: {
			viewPricingArray: {
				type: Array,
				default: null
			},
		},
		data(){
        	return {

				}
			},
			computed:{
				...mapState(['isCashier', 'userDepCurrencyName']),
				fieldsForPricingItems() {
					return [
						{
							key: 'number',
							label: '№',
							sortable: true
						},
						{
							key: 'itemName',
							label: this.$t('incomes.create.product'),
							'class': 'min-60',
							sortable: true
						},
						{
							key: 'artikul',
							'class': 'role_id',
							label: this.$t('goods.artikul'),
						},
						{
							key: 'color',
							label: this.$t('goods.create.color'),
						},
						{
							key: 'barcode',
							label: this.$t('goods.barcode')
						},
						{
							key: 'incomingPriceUzs',
							label: this.$t('prices.item.sum')
						},
						{
							key: 'priceUzs',
							label: this.$t('prices.item.lastPriceUzs')
						},
						{
							key: 'priceWholesale',
							label: this.$t('prices.item.lastPriceWholesale')
						},
					]
				},
			}

    }
</script>

<style scoped>

</style>
